export const ON_BDC_SET_FILTERS_DATA = "ON_BDC_SET_FILTERS_DATA";
export const ON_BDC_SET_CONVENIOS_DATA = "ON_BDC_SET_CONVENIOS_DATA";
export const SET_AGRO_ERROR = "SET_AGRO_ERROR";
export const CLEAR_AGRO_ERROR = "CLEAR_AGRO_ERROR";
